import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnInit,
	Output,
} from '@angular/core';
import { FreudMessageService } from '@freud-ds/web-components';
import { TranslateService } from '@ngx-translate/core';
import {
	INTERACTION_TYPE,
	ITEM_TYPE,
	SCOPE_TYPE,
	SUBSCOPE_TYPE,
} from 'app/interfaces/actiontracker.interface';
import { IContactListResponse } from 'app/interfaces/contact.interface';
import { ActionTrackerService } from 'app/services/actiontracker.service';
import { ContactsService } from 'app/services/contacts.service';
import { ProfessionalService } from 'app/services/professional.service';

type Options = { label: string; value: string };

@Component({
	selector: 'contact-bulk-message',
	templateUrl: './contact-bulk-message.component.html',
	styleUrls: ['./contact-bulk-message.component.scss'],
})
export class ContactBulkMessageComponent implements OnInit, OnChanges {
	_selectedContacts: string[] = [];
	_options: Options[] = [];
	disabledSelect = false;
	invalidSelect = false;
	_message = '';
	invalidText = false;
	sendingMessage = false;
	changeDefaultMessage = false;
	isLoading = true;

	@Input() type = 'custom';
	@Input() visible = false;
	@Input() selectedContacts: string[] = [];
	@Input() message: string;
	@Output() onSendMessage: EventEmitter<any> = new EventEmitter<any>();
	@Output() closeModal: EventEmitter<{ messageSended?: boolean }> =
		new EventEmitter<{ messageSended?: boolean }>();

	constructor(
		public contactsService: ContactsService,
		public professionalService: ProfessionalService,
		public toast: FreudMessageService,
		private translate: TranslateService,
		public actionTracker: ActionTrackerService
	) {}

	ngOnInit(): void {
		this._message = this.message;
		this.getContacts();
	}

	ngOnChanges() {
		this._selectedContacts = this.selectedContacts;
	}

	getContacts() {
		this.contactsService
			.getContacts('', 1000)
			.subscribe((res: IContactListResponse): void => {
				if (res && res.contacts) {
					this._options = res.contacts
						.filter((contact) => contact.refUserId)
						.map((contact) => {
							return {
								label: contact.displayName,
								value: contact.refUserId,
							};
						});
					this.isLoading = false;
				}
			});
	}

	sendMessage(): void {
		this.sendingMessage = true;
		this.professionalService
			.sendMessage({
				userIds: this._selectedContacts,
				message: this._message,
			})
			.subscribe(
				() => {
					this.triggerSucessMessage();
					this.trackMessageSend();
					this.close(true);
					this.onSendMessage.emit();
					this.sendingMessage = false;
				},
				() => {
					this.triggerErrorMessage();
					this.trackMessageError();
					this.close(false);
					this.sendingMessage = false;
				}
			);
	}

	close(closeBanner?: boolean): void {
		this.visible = false;
		this.closeModal.emit({ messageSended: !!closeBanner });
	}

	triggerSucessMessage() {
		this.toast.add({
			severity: 'success',
			summary: this.translate.instant(
				'CONTACT.BANNER_INACTIVE_CLIENTS.FEEDBACK.SUCCESS.TITLE'
			),
			detail: this.translate.instant(
				'CONTACT.BANNER_INACTIVE_CLIENTS.FEEDBACK.SUCCESS.DESCRIPTION'
			),
		});
	}

	triggerErrorMessage() {
		this.toast.add({
			severity: 'error',
			summary: this.translate.instant(
				'CONTACT.BANNER_INACTIVE_CLIENTS.FEEDBACK.FAIL.TITLE'
			),
			detail: this.translate.instant(
				'CONTACT.BANNER_INACTIVE_CLIENTS.FEEDBACK.FAIL.DESCRIPTION'
			),
		});
	}

	trackMessageSend() {
		this.actionTracker.eventTracker(
			SCOPE_TYPE.Contact,
			this.type === 'inactive'
				? SUBSCOPE_TYPE.InactiveBulkMessage
				: SUBSCOPE_TYPE.CustomBulkMessage,
			ITEM_TYPE.Send,
			INTERACTION_TYPE.Success,
			{
				quantity: this._selectedContacts.length,
			}
		);
	}

	trackMessageError() {
		this.actionTracker.eventTracker(
			SCOPE_TYPE.Contact,
			this.type === 'inactive'
				? SUBSCOPE_TYPE.InactiveBulkMessage
				: SUBSCOPE_TYPE.CustomBulkMessage,
			ITEM_TYPE.Send,
			INTERACTION_TYPE.Error,
			{
				quantity: this._selectedContacts.length,
			}
		);
	}
}
